let sessionId = null;
document.addEventListener("DOMContentLoaded", () => {
  sessionId = crypto.randomUUID();
  // --- STATE MANAGEMENT ---
  let currentStep = 1;
  let fullApiData = null;
  let selectedFile = null;
  let capturedData = {
    email: null,
    phone: null,
    birthday: null,
  };

  // --- DOM Element Selection ---
  const journeyContainer = document.getElementById("shade-finder-journey");
  if (!journeyContainer) {
    console.warn(
      "Shade Finder journey container not found. Script will not run."
    );
    return;
  }
  const beginBtn = document.getElementById("shade-begin");
  const nextInstructionsBtn = document.getElementById("shade-next-instructions");
  const fileInput = document.getElementById("shade-input");
  const errorBox = document.getElementById("shade-error-box");
  const emailForm = document.getElementById("shade-email-form");
  const phoneForm = document.getElementById("shade-phone-form");
  const birthdayForm = document.getElementById("shade-birthday-form");
  const skipEmailBtn = document.getElementById("shade-skip-email-btn");
  const skipPhoneBtn = document.getElementById("shade-skip-phone-btn");
  const skipBirthdayBtn = document.getElementById("shade-skip-birthday-btn");
  const emailInput = document.getElementById("shade-email-input");
  const emailSubmitBtn = document.querySelector(
    '#shade-email-form .button[type="submit"]'
  );
  const emailFormError = document.getElementById("email-form-error");
  const phoneInput = document.getElementById("shade-phone-input");
  const phoneSubmitBtn = document.querySelector(
    '#shade-phone-form .button[type="submit"]'
  );
  const birthdayInput = document.getElementById("shade-birthday-input");
  const birthdaySubmitBtn = document.querySelector(
    '#shade-birthday-form .button[type="submit"]'
  );
  // Consent Step Elements
  const consentForm = document.getElementById("shade-consent-form");
  const consentPrivacyCheck = document.getElementById("consent-privacy");
  const consentProcessingCheck = document.getElementById("consent-processing");
  const consentContinueBtn = document.getElementById("shade-consent-continue");

  // --- HELPER FUNCTIONS ---
  const toTitleCase = (str) =>
    str.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );

  const changeStep = (nextStep) => {
    const currentStepEl = journeyContainer.querySelector(
      ".step-" + currentStep
    );
    const nextStepEl = journeyContainer.querySelector(".step-" + nextStep);
    if (currentStepEl) currentStepEl.classList.remove("active");
    if (nextStepEl) nextStepEl.classList.add("active");
    currentStep = nextStep;

    // This scrolls the user to the top of the component on each step change
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const showError = (message) => {
    errorBox.innerHTML = `<p class="form__message errors"><span>${message}</span></p>`;
    errorBox.style.display = "block";
    changeStep(4); // Error shows on the new photo upload step
  };

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const showFormError = (errorEl, message) => {
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = "block";
    }
  };

  const hideFormError = (errorEl) => {
    if (errorEl) {
      errorEl.style.display = "none";
    }
  };

  const manageButtonState = (inputEl, buttonEl) => {
    if (!inputEl || !buttonEl) return;
    buttonEl.classList.add("button--disabled");
    inputEl.addEventListener("input", () => {
      if (inputEl.value.trim() !== "") {
        buttonEl.classList.remove("button--disabled");
      } else {
        buttonEl.classList.add("button--disabled");
      }
    });
  };

  // --- Swiper Initialization ---
  const setupSwiper = (selector, options) => {
    const swiperElement = document.querySelector(selector);
    if (!swiperElement || typeof Swiper === "undefined") {
      return null;
    }
    return new Swiper(swiperElement, options);
  };

  const setupComplementarySwiper = () => {
    const swiperSelector = ".complementary-carousel";
    const swiperElement = document.querySelector(swiperSelector);
    if (!swiperElement) return;

    let complementarySwiper = null;

    const handleResize = () => {
      const isMobile = window.innerWidth < 750;
      if (isMobile && !complementarySwiper) {
        complementarySwiper = setupSwiper(swiperSelector, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          centeredSlides: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      } else if (!isMobile && complementarySwiper) {
        complementarySwiper.destroy();
        complementarySwiper = null;
      }
    };

    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);
  };

  const initializeOkendoWidgets = () => {
    const init = () => {
      const widgets = document.querySelectorAll(
        "[data-oke-carousel]:not(.oke-initialized)"
      );
      if (widgets.length > 0) {
        widgets.forEach((widget) => {
          if (
            window.okeWidgetApi &&
            typeof window.okeWidgetApi.initWidget === "function"
          ) {
            window.okeWidgetApi.initWidget(widget);
          }
        });
      }
    };
    if (
      window.okeWidgetApi &&
      typeof window.okeWidgetApi.initWidget === "function"
    ) {
      init();
    } else {
      document.addEventListener("oke-init", init);
    }
  };

  // --- CORE LOGIC ---
  const fetchMatchData = async () => {
    if (!selectedFile) {
      showError("No file selected. Please go back and select a photo.");
      return;
    }
    changeStep(5); // Go to processing step
    errorBox.style.display = "none";
    const form = new FormData();
    form.append("selfie", selectedFile);
    form.append("session_id", sessionId);
    try {
      const res = await fetch(apiUrl + "/match", {
        method: "POST",
        headers: {
          "X-API-Key": apiKey,
        },
        body: form,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "An unknown error occurred.");
      fullApiData = data;
      changeStep(6); // Go to email form step
    } catch (err) {
      showError(
        err.message || "An unexpected error occurred. Please try again."
      );
    }
  };

  const saveAndReveal = async () => {
    if (capturedData.email || capturedData.phone || capturedData.birthday) {
      try {
        await fetch(apiUrl + "/save-results", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": apiKey,
          },
          body: JSON.stringify({
            ...capturedData,
            shade_match: fullApiData.match,
            session_id: sessionId,
          }),
        });
      } catch (err) {
        console.error("Error saving contact info:", err);
      }
    }
    revealFinalMatch(fullApiData.match);
  };

  function setupProductGalleries() {
    const galleryCards = document.querySelectorAll(
      ".card--product.has-gallery"
    );
    galleryCards.forEach((card) => {
      const swiperContainer = card.querySelector(".card-gallery.swiper");
      const thumbnails = card.querySelectorAll(".card-gallery-thumbnail");

      if (!swiperContainer || thumbnails.length === 0) return;

      const gallerySwiper = new Swiper(swiperContainer, {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: function() {
            const activeIndex = this.activeIndex;
            thumbnails.forEach((thumb, index) => {
              if (index === activeIndex) {
                thumb.classList.add("active");
              } else {
                thumb.classList.remove("active");
              }
            });
          },
        },
      });

      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
          gallerySwiper.slideTo(index);
        });
      });
    });
  }

  function buildImageGallery(cardData) {
    const imageUrls = [
      cardData.image_url,
      cardData.b_a_image_url,
      cardData.clinical_image_url,
      cardData.ingredients_image_url,
    ].filter(Boolean);

    if (imageUrls.length === 0) {
      return `<div class="card__media"><img src="https://placehold.co/400x400/EEE/31343C?text=Image+Not+Found" alt="Placeholder Image"></div>`;
    }

    const placeholderUrl =
      "https://placehold.co/400x400/EEE/31343C?text=Image+Not+Found";

    const slidesHtml = imageUrls
      .map(
        (url) => `
        <div class="swiper-slide">
          <a href="/products/${cardData.handle}?variant=${cardData.variant}">
            <img src="${url}" alt="${cardData.title}" loading="lazy" onerror="this.onerror=null;this.src='${placeholderUrl}';">
          </a>
        </div>
      `
      )
      .join("");

    const thumbnailsHtml = imageUrls
      .map(
        (url, index) => `
        <img
          src="${url}"
          alt="Thumbnail ${index + 1}"
          class="card-gallery-thumbnail ${index === 0 ? "active" : ""}"
          onerror="this.onerror=null;this.src='${placeholderUrl}';"
        >
      `
      )
      .join("");

    return `
      <div class="card__media">
        <div class="card-gallery swiper">
          <div class="swiper-wrapper">${slidesHtml}</div>
          <div class="swiper-pagination"></div>
        </div>
        <div class="card-gallery-thumbnails">${thumbnailsHtml}</div>
      </div>
    `;
  }

  async function buildCard(
    cardData,
    isMinorCard,
    isMainMatch = false,
    isForAlternateStep = false
  ) {
    const {
      handle,
      variant: variantId,
      shade,
      undertone,
      reasoning
    } = cardData;
    if (!handle || !variantId) return "";

    try {
      const product = await fetch(`/products/${handle}.js`).then((r) =>
        r.json()
      );
      const variant = product.variants.find((v) => v.id === variantId);
      if (!variant)
        throw new Error(`Variant ${variantId} not found in product ${handle}`);

      const title = product.title;
      const isFoundation = handle === "more-than-a-pretty-face-foundation";
      const cardClasses = `card--product ${isMainMatch ? "is-match" : ""} ${
        isForAlternateStep ? "card--alternate" : ""
      } ${isFoundation ? "has-gallery" : ""}`;

      let buttonHtml;
      if (isForAlternateStep) {
        buttonHtml = `<button class="button select-alternate-btn" data-variant-id="${variantId}">Select This Shade</button>`;
      } else if (isMinorCard) {
        // minor complementary product uses text link
        buttonHtml = `<a href="#" class="card-add-link" data-variant-id="${variantId}">Add to Cart</a>`;
      } else {
        buttonHtml = `<button type="button" class="button button--pill card-add-button" data-variant-id="${variantId}">Add to Cart</button>`;
      }

      const reasoningHtml =
        (isMinorCard || isForAlternateStep) && reasoning ?
        `<div class="reasoning-wrapper"><p class="card-reasoning">${reasoning}</p></div>` :
        `<div class="reasoning-wrapper"></div>`;

      let nameHtml;
      if (isFoundation) {
        const finalShade = toTitleCase(shade || variant.option1);
        const finalUndertone = toTitleCase(undertone || variant.option2);
        nameHtml = `<p class="card-shade-name">Shade: ${finalShade} ${finalUndertone}</p>`;
      } else if (isMinorCard && cardData.color) {
        nameHtml = `<p class="card-shade-name">Color: ${toTitleCase(
          cardData.color
        )}</p>`;
      } else {
        nameHtml = "";
      }

      const mediaHtml = isFoundation ?
        buildImageGallery({
          ...cardData,
          title: product.title,
          handle: product.handle,
        }) :
        `<div class="card__media"><a href="/products/${handle}?variant=${variantId}"><img src="${
            cardData.image_url ||
            variant?.featured_image?.src ||
            product.featured_image
          }" alt="${title}" loading="lazy" /></a></div>`;

      return `
        <div class="${cardClasses}" data-variant-id="${variantId}">
          ${mediaHtml}
          <div class="card__info">
            <a href="/products/${handle}?variant=${variantId}" class="card-title-link">${title}</a>
            ${nameHtml}
            <p class="card-price">$${(variant.price / 100).toFixed(2)}</p>
            ${reasoningHtml}
            <div class="card-footer">${buttonHtml}</div>
          </div>
        </div>`;
    } catch (e) {
      console.error("Error building card:", e);
      return "";
    }
  }

  async function revealFinalMatch(matchToShow, isSwitching = false) {
    if (!matchToShow) {
      showError(
        "Could not find a suitable match. Please try retaking your photo in better light."
      );
      return;
    }
    const resultsStep = journeyContainer.querySelector(
      ".step-9 .shade-step__inner"
    );
    if (!resultsStep) return;

    let resultsHtml = `<div class="results-group">
      ${await buildCard(matchToShow, false, true)}
      <a href="/pages/shade-match-guarantee" class="guarantee-banner-text" target="_blank" rel="noopener noreferrer">
        <div class="guarantee-text">
          <div class="guarantee-headline">100% Shade Match Guarantee!</div>
          <p>If you're unhappy with your order, swap it for a different shade for FREE within 21 days.</p>
        </div>
      </a>
    </div>`;

    const complementaryProducts = fullApiData.complementary_products || [];
    if (complementaryProducts.length > 0) {
      const bundleCards = await Promise.all(
        complementaryProducts.map(
          async (p) =>
          `<div class="swiper-slide">${await buildCard(p, true)}</div>`
        )
      );
      resultsHtml += `
        <div class="results-group">
          <h2 class="h2 center">Complete Your Look</h2>
          <div class="complementary-carousel swiper">
            <div class="swiper-wrapper">${bundleCards.join("")}</div>
            <div class="swiper-pagination"></div>
          </div>
          <div class="center element-margin-small">
            <button id="add-all-to-cart" class="button">Add All to Cart</button>
          </div>
        </div>`;
    }

    resultsHtml += `
      <div class="results-group okendo-reviews-group">
        <h2 class="h2 center">Spoiler: They’re Obsessed</h2>
        <div data-oke-carousel data-oke-reviews-group-id="01f0ce03-cbc5-4a2c-870d-2cbbf6dab90f"></div>
      </div>`;
    resultsStep.innerHTML = resultsHtml;

    setupComplementarySwiper();
    setupProductGalleries();
    initializeOkendoWidgets();

    const reasoningContainer = document.createElement("div");
    reasoningContainer.id = "ai-reasoning-box";
    resultsStep.prepend(reasoningContainer);

    if (fullApiData.reasoning && typeof fullApiData.reasoning === "object") {
      const {
        why_body
      } = fullApiData.reasoning;
      const shadeName = toTitleCase(
        `${matchToShow.shade} ${matchToShow.undertone}`
      );
      const newHeading = `Your perfect match is ${shadeName}!`;
      reasoningContainer.innerHTML = `<div class="ai-reasoning"><h3>${newHeading}</h3><p>${why_body}</p></div>`;
    }

    const alternatesContainer = document.createElement("div");
    alternatesContainer.id = "show-alternates-container";
    alternatesContainer.style.textAlign = "center";
    alternatesContainer.style.marginTop = "2rem";
    resultsStep.append(alternatesContainer);
    alternatesContainer.innerHTML =
      fullApiData.alternates?.length > 0 ?
      `<button id="show-alternates-btn" class="button button--secondary">Show me other options</button>` :
      "";

    if (!isSwitching) {
      changeStep(9); // Go to results step
    }
  }

  const showAlternates = async () => {
    const alternates = fullApiData.alternates || [];
    if (alternates.length === 0) return;

    const alternatesStep = journeyContainer.querySelector(
      ".step-10 .shade-step__inner"
    );
    if (!alternatesStep) return;

    const alternateCards = await Promise.all(
      alternates.map((alt) => buildCard(alt, false, false, true))
    );
    alternatesStep.innerHTML = `<h2 class="h2 center">Alternate Shades</h2><div class="card-grid">${alternateCards.join(
      ""
    )}</div>`;
    changeStep(10); // Go to alternates step
    setupProductGalleries();
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      selectedFile = file;
      fetchMatchData();
    }
  };

  if (beginBtn) beginBtn.addEventListener("click", () => changeStep(2));
  if (nextInstructionsBtn)
    nextInstructionsBtn.addEventListener("click", () => changeStep(3));
  if (fileInput) fileInput.addEventListener("change", handleFileSelect);

  // Consent Form Logic
  if (consentForm) {
    const checkConsentState = () => {
      if (consentPrivacyCheck.checked && consentProcessingCheck.checked) {
        consentContinueBtn.classList.remove("button--disabled");
      } else {
        consentContinueBtn.classList.add("button--disabled");
      }
    };

    [consentPrivacyCheck, consentProcessingCheck].forEach((box) => {
      box.addEventListener("change", checkConsentState);
    });

    consentForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (consentContinueBtn.classList.contains("button--disabled")) return;

      consentContinueBtn.textContent = "Continuing...";
      consentContinueBtn.classList.add("button--disabled");

      try {
        await fetch(apiUrl + "/log-consent", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": apiKey
          },
          body: JSON.stringify({ session_id: sessionId }),
        });
      } catch (err) {
        console.error("Consent logging failed:", err);
      } finally {
        changeStep(4); // Proceed to photo upload step
      }
    });
  }

  manageButtonState(emailInput, emailSubmitBtn);
  manageButtonState(phoneInput, phoneSubmitBtn);
  manageButtonState(birthdayInput, birthdaySubmitBtn);

  if (emailForm) {
    emailForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const email = emailInput.value.trim();
      if (!email) {
        hideFormError(emailFormError);
        changeStep(7); // Go to phone step
        return;
      }
      if (validateEmail(email)) {
        capturedData.email = email;
        hideFormError(emailFormError);
        changeStep(7); // Go to phone step
      } else {
        showFormError(emailFormError, "Please enter a valid email address.");
      }
    });
  }
  if (skipEmailBtn) {
    skipEmailBtn.addEventListener("click", () => {
      hideFormError(emailFormError);
      changeStep(7); // Go to phone step
    });
  }

  if (phoneForm) {
    phoneForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const phone = phoneInput.value;
      if (phone) {
        capturedData.phone = phone.replace(/\D/g, "");
      }
      changeStep(8); // Go to birthday step
    });
  }
  if (skipPhoneBtn) skipPhoneBtn.addEventListener("click", () => changeStep(8));

  if (birthdayForm) {
    birthdayForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const birthday = birthdayInput.value;
      if (birthday) {
        capturedData.birthday = birthday;
      }
      saveAndReveal();
    });
  }
  if (skipBirthdayBtn) skipBirthdayBtn.addEventListener("click", saveAndReveal);

  document.body.addEventListener("click", async (e) => {
    if (e.target.id === "show-alternates-btn") {
      showAlternates();
    }
    if (e.target.matches(".select-alternate-btn")) {
      e.preventDefault();
      const variantId = parseInt(e.target.dataset.variantId, 10);
      const newMatch = fullApiData.alternates.find(
        (alt) => alt.variant === variantId
      );
      if (newMatch) {
        const oldMatch = fullApiData.match;
        fullApiData.match = newMatch;
        fullApiData.alternates = fullApiData.alternates.filter(
          (alt) => alt.variant !== variantId
        );
        fullApiData.alternates.push(oldMatch);
        const newBundle = fullApiData.all_bundles[newMatch.variant];
        fullApiData.complementary_products = newBundle || [];
        await revealFinalMatch(newMatch, true);
        changeStep(9);
      }
    }
    if (e.target.matches(".card-add-button, .card-add-link")) {
      e.preventDefault();
      const variantId = e.target.dataset.variantId;
      const shadeName = `${fullApiData.match.shade} ${fullApiData.match.undertone}`;
      const button = e.target;
      button.textContent = "Adding...";
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: {
                "AI Shade Finder": "true",
                "Matched Shade": shadeName
              }
            }]
          }),
        });
        button.textContent = "Added!";
        setTimeout(() => (button.textContent = "Add to Cart"), 2000);
      } catch (err) {
        button.textContent = "Error";
        setTimeout(() => (button.textContent = "Add to Cart"), 2000);
      }
    }
    if (e.target.id === "add-all-to-cart") {
      e.preventDefault();
      const button = e.target;
      button.textContent = "Adding...";
      const complementaryItems = (fullApiData.complementary_products || []).map(
        (p) => ({ id: p.variant, quantity: 1 })
      );
      const foundationItem = { id: fullApiData.match.variant, quantity: 1 };
      const itemsToAdd = [foundationItem, ...complementaryItems];
      const shadeName = `${fullApiData.match.shade} ${fullApiData.match.undertone}`;
      const itemsWithProps = itemsToAdd.map(item => ({
        ...item,
        properties: {
          "AI Shade Finder": "true",
          "Matched Shade": shadeName
        }
      }));
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: itemsWithProps })
        });
        button.textContent = "Added All!";
        setTimeout(() => (button.textContent = "Add All to Cart"), 2000);
      } catch (err) {
        button.textContent = "Error";
        setTimeout(() => (button.textContent = "Add All to Cart"), 2000);
      }
    }
  });

  const style = document.createElement("style");
  style.innerHTML = `html, body { overflow-x: hidden !important; width: 100% !important; max-width: 100vw !important; }`;
  document.head.appendChild(style);

  // Re-bind step 1 button in case of override
  const beginBtnRe = document.getElementById("shade-begin");
  if (beginBtnRe) {
    beginBtnRe.addEventListener("click", () => changeStep(2));
  }

});